import { Button, Grid, Icon, Menu, ToggleButton, ToggleButtonGroup } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { getUserData } from "Utils/helpers";

import { useSoftUIController } from "context";
import SoftTypography from "components/SoftTypography";
import CheckIcon from "@mui/icons-material/Check";

let fullOddsStyles = [];

function MarketGroupsView({ groups, selectedGroup, informParent, blockChanges }) {
  const [controller] = useSoftUIController();
  const { platform, permissions } = controller;

  const [marketGroups, setMarketGroups] = useState(null);
  const [selectedMarketGroup, setSelectedMarketGroup] = useState(999999);
  const [forceClose, setForceClose] = useState(true);
  const [operatorFunctionality, setOperatorFunctionality] = useState(false);

  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [reportEnabled, setReportEnabled] = useState(false);

  const [oddsStyles, setOddsStyles] = useState(["decimal"]);
  const [selectedOddsStyles, setSelectedOddsStyles] = useState(["decimal"]);
  const [openOddsStylesMenu, setOpenOddsStylesMenu] = useState(false);

  function marketGroupChangeHandler(e, id) {
    e.preventDefault();
    informParent(e, id);
    if (id >= 0) setSelectedMarketGroup(id);
    if (id == -1) forceClose ? setForceClose(false) : setForceClose(true);
    if (id == -2) setSelectedMarketGroup(id); // suspened Markets
    if (id == -3) setSelectedMarketGroup(id); // Markets with without Name
    if (id == -4) setSelectedMarketGroup(id); // Markets with odds without label
  }

  function enableOperatorFunctionality() {
    if (permissions) {
      let userData = getUserData();
      for (let index = 0; index < userData.roles.length; index++) {
        const role = userData.roles[index];
        if (role.id < 50) {
          setOperatorFunctionality(true);
        }
      }
    }
  }

  function betAllOdds(e) {
    e.preventDefault();
    informParent(e, "betAll");
    setReportEnabled(true);
  }

  function lastBetsReport(e) {
    e.preventDefault();
    informParent(e, "betsReport");
  }

  // Render the notifications menu
  const renderUserMenu = () => (
    <Menu
      anchorEl={openOddsStylesMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openOddsStylesMenu)}
      onClose={handleCloseOddsStylesMenu}
      sx={{ mt: 2 }}
    >
      <SoftBox>
        <Grid>
          <ToggleButtonGroup
            orientation="vertical"
            value={oddsStyles}
            onChange={handleOddsStylesChange}
            aria-label="device"
          >
            {oddsStyles &&
              oddsStyles.map((oddsStyle) => {
                return (
                  <ToggleButton
                    key={oddsStyle}
                    className={"opacity-revert"}
                    value={oddsStyle}
                    aria-label={oddsStyle}
                    sx={{ opacity: "100%" }}
                  >
                    <SoftTypography
                      variant="normal"
                      component="div"
                      style={{ minWidth: "100%", textAlign: "left", paddingLeft: "10px" }}
                    >
                      {oddsStyle}
                    </SoftTypography>
                    <CheckIcon
                      className={"opacity-revert"}
                      style={{
                        opacity: "100% !important",
                        display: selectedOddsStyles == oddsStyle ? "" : "none",
                      }}
                      color={"success"}
                    />
                  </ToggleButton>
                );
              })}
          </ToggleButtonGroup>
        </Grid>
      </SoftBox>
    </Menu>
  );

  const handleOddsStylesChange = (event, oddsStyle) => {
    event.preventDefault();
    if (oddsStyle.length) {
      setOddsStyles(fullOddsStyles);
      setSelectedOddsStyles(event.currentTarget.value);
      informParent(event, "oddsStyle");
    }
  };

  const handleOpenOddsStylesMenu = (event) => {
    event.preventDefault();
    setOpenOddsStylesMenu(event.currentTarget);
  };

  const handleCloseOddsStylesMenu = () => {
    setOpenOddsStylesMenu(false);
  };

  useEffect(() => {
    // console.log("setMarketGroups: ", groups);
    setMarketGroups(groups);
    setOddsStyles(platform.odds_styles);
    fullOddsStyles = platform.odds_styles;
    // console.log(platform.odds_styles);
  }, [groups]);

  useEffect(() => {
    setOddsStyles(platform.odds_styles);
    fullOddsStyles = platform.odds_styles;
    // console.log(platform.odds_styles);
  }, [platform]);

  useEffect(() => {
    // console.log("setSelectedGroups: ", selectedGroup);
    if (selectedGroup) setSelectedMarketGroup(selectedGroup);
  }, [selectedGroup]);

  useEffect(() => {
    if (permissions) enableOperatorFunctionality();
  }, [permissions]);

  return (
    <SoftBox style={{ display: "flex", width: "calc(100% - 170px)" }}>
      <SoftBox
        style={{
          display: "flex",
          maxWidth: operatorFunctionality ? "calc(100% - 300px)" : "calc(100% - 170px)",
        }}
      >
        <Grid container>
          <Grid item>
            <Button
              key={999999}
              size="small"
              onClick={(e) => marketGroupChangeHandler(e, 999999)}
              color={selectedMarketGroup === 999999 ? "info" : "secondary"}
            >
              All
            </Button>
          </Grid>
          {marketGroups
            ? marketGroups.map((mg, index) => {
                return (
                  <Grid item key={index}>
                    <Button
                      size="small"
                      onClick={(e) => marketGroupChangeHandler(e, mg.id)}
                      color={selectedMarketGroup === mg.id ? "info" : "secondary"}
                    >
                      {mg.label || mg.name}
                    </Button>
                  </Grid>
                );
              })
            : ""}
        </Grid>
      </SoftBox>
      {/* <div style={{ width: "100%" }}></div> */}
      <SoftBox
        style={{ position: "absolute", right: "380px" }}
        sx={{ display: operatorFunctionality ? "" : "none" }}
      >
        <Button
          title="Filter suspended Markets"
          sx={{ width: "30px", minWidth: "30px", maxWidth: "30px" }}
          onClick={(e) => marketGroupChangeHandler(e, -2)}
        >
          <Icon>lock_outlined_icon </Icon>
        </Button>
        <Button
          title="Filter Markets without Name"
          sx={{ width: "30px", minWidth: "30px", maxWidth: "30px" }}
          onClick={(e) => marketGroupChangeHandler(e, -3)}
        >
          <Icon>error_outline_outlined_iIcon </Icon>
        </Button>
        <Button
          title="Filter Markets with Odds without label"
          sx={{ width: "30px", minWidth: "30px", maxWidth: "30px" }}
          onClick={(e) => marketGroupChangeHandler(e, -4)}
        >
          <Icon>sms_failed_outlined_icon </Icon>
        </Button>
      </SoftBox>
      <SoftBox
        sx={{ width: "235px", minWidth: "235px", maxWidth: "235px" }}
        style={{ position: "absolute", right: operatorFunctionality ? "145px" : "15px" }}
      >
        <Button
          sx={{ width: "30px", minWidth: "30px", maxWidth: "30px" }}
          onClick={(e) => marketGroupChangeHandler(e, -1)}
          title="Expand/Collapse Markets"
        >
          <Icon
            style={{
              width: "30px",
              minWidth: "30px",
              maxWidth: "30px",
              display: forceClose ? "none" : "",
            }}
          >
            expand_outlined_icon
          </Icon>
          <Icon
            style={{
              width: "30px",
              minWidth: "30px",
              maxWidth: "30px",
              display: forceClose ? "" : "none",
            }}
          >
            compress_outlined_icon{" "}
          </Icon>
        </Button>
        <SoftButton
          size="small"
          sx={{ padding: "0px 6px !important", lineHeight: "1", height: "25px", minHeight: "10px" }}
          variant="contained"
          color={blockChanges ? "error" : "dark"}
          disabled={!blockChanges}
          onClick={(e) => informParent(e, "saveBlocked")}
        >
          Save Changes
        </SoftButton>
        <SoftButton
          size="small"
          sx={{ padding: "0px 6px !important", lineHeight: "1", height: "25px", minHeight: "10px" }}
          variant="contained"
          color="warning"
          onClick={handleOpenOddsStylesMenu}
        >
          {" Odds Styles "}
        </SoftButton>
        {renderUserMenu()}
      </SoftBox>
      <SoftBox
        sx={{ width: "140px", minWidth: "140px", maxWidth: "140px" }}
        style={{ position: "absolute", right: "5px", display: operatorFunctionality ? "" : "none" }}
      >
        <SoftBox>
          <SoftButton
            size="small"
            sx={{ padding: "0px !important", lineHeight: "1", height: "25px", minHeight: "10px" }}
            variant="contained"
            color="success"
            onClick={betAllOdds}
          >
            Bet All
          </SoftButton>
          <SoftButton
            size="small"
            sx={{
              padding: "0px !important",
              lineHeight: "1",
              height: "25px",
              minHeight: "10px",
            }}
            disabled={reportEnabled ? false : true}
            variant="contained"
            color="info"
            onClick={lastBetsReport}
          >
            Bets
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the DataTable
MarketGroupsView.propTypes = {
  groups: PropTypes.array,
  selectedGroup: PropTypes.number,
  informParent: PropTypes.func,
  blockChanges: PropTypes.bool,
};
export default MarketGroupsView;
